export const LOGO_URL = `${process.env.PUBLIC_URL || ""}/ink-genius-logo.webp`;
const ALT = "Ink Genius — AI-Powered Pigment Intelligence by MooreBeautyLove";

const SIZES = {
  xl: "h-[360px] sm:h-[460px] lg:h-[540px]",
  lg: "h-64 sm:h-80",
  md: "h-44 sm:h-52",
  sm: "h-28",
};

export function InkCharacter({ size = "lg", className = "" }) {
  return (
    <img src={LOGO_URL} alt={ALT} data-testid="ink-genius-logo"
      className={`${SIZES[size]} w-auto select-none object-contain ${className}`} draggable={false} />
  );
}
